export { default, FilterIconName as MapViewIconName } from '../filters/FilterIcon';
